import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiUser, FiLogOut, FiShoppingBag, FiMapPin, FiEye, FiEyeOff } from 'react-icons/fi';
import { auth, firebaseAuth } from '../utils/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import apiClient from '../utils/apiClient';
import { useToast } from '../context/ToastContext';
import Addresses from '../components/Addresses';
import '../styles/Account.css';
import '../styles/LoginButton.css';

// Simplified Account component with separate state for each field

const Account = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const toast = useToast();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [activeTab, setActiveTab] = useState('profile');
  const [mode, setMode] = useState('login'); // 'login' or 'signup'
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [userInfo, setUserInfo] = useState({
    name: '',
    email: '',
    phone: '',
  });

  const [form, setForm] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    name: '',
    phone: '',
    otp: '',
    emailOtp: ''
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [emailOtpSent, setEmailOtpSent] = useState(false);

  const [phoneAuth, setPhoneAuth] = useState({
    verificationId: null,
    isOtpSent: false,
    isPhoneMode: false,
    countryCode: '+91' // Default to India
  });

  // Country codes for dropdown
  const countryCodes = [
    { code: '+1', country: 'United States', flag: '🇺🇸' },
    { code: '+7', country: 'Russia', flag: '🇷🇺' },
    { code: '+20', country: 'Egypt', flag: '🇪🇬' },
    { code: '+27', country: 'South Africa', flag: '🇿🇦' },
    { code: '+30', country: 'Greece', flag: '🇬🇷' },
    { code: '+31', country: 'Netherlands', flag: '🇳🇱' },
    { code: '+32', country: 'Belgium', flag: '🇧🇪' },
    { code: '+33', country: 'France', flag: '🇫🇷' },
    { code: '+34', country: 'Spain', flag: '🇪🇸' },
    { code: '+36', country: 'Hungary', flag: '🇭🇺' },
    { code: '+39', country: 'Italy', flag: '🇮🇹' },
    { code: '+40', country: 'Romania', flag: '🇷🇴' },
    { code: '+41', country: 'Switzerland', flag: '🇨🇭' },
    { code: '+43', country: 'Austria', flag: '🇦🇹' },
    { code: '+44', country: 'United Kingdom', flag: '🇬🇧' },
    { code: '+45', country: 'Denmark', flag: '🇩🇰' },
    { code: '+46', country: 'Sweden', flag: '🇸🇪' },
    { code: '+47', country: 'Norway', flag: '🇳🇴' },
    { code: '+48', country: 'Poland', flag: '🇵🇱' },
    { code: '+49', country: 'Germany', flag: '🇩🇪' },
    { code: '+51', country: 'Peru', flag: '🇵🇪' },
    { code: '+52', country: 'Mexico', flag: '🇲🇽' },
    { code: '+53', country: 'Cuba', flag: '🇨🇺' },
    { code: '+54', country: 'Argentina', flag: '🇦🇷' },
    { code: '+55', country: 'Brazil', flag: '🇧🇷' },
    { code: '+56', country: 'Chile', flag: '🇨🇱' },
    { code: '+57', country: 'Colombia', flag: '🇨🇴' },
    { code: '+58', country: 'Venezuela', flag: '🇻🇪' },
    { code: '+60', country: 'Malaysia', flag: '🇲🇾' },
    { code: '+61', country: 'Australia', flag: '🇦🇺' },
    { code: '+62', country: 'Indonesia', flag: '🇮🇩' },
    { code: '+63', country: 'Philippines', flag: '🇵🇭' },
    { code: '+64', country: 'New Zealand', flag: '🇳🇿' },
    { code: '+65', country: 'Singapore', flag: '🇸🇬' },
    { code: '+66', country: 'Thailand', flag: '🇹🇭' },
    { code: '+81', country: 'Japan', flag: '🇯🇵' },
    { code: '+82', country: 'South Korea', flag: '🇰🇷' },
    { code: '+84', country: 'Vietnam', flag: '🇻🇳' },
    { code: '+86', country: 'China', flag: '🇨🇳' },
    { code: '+90', country: 'Turkey', flag: '🇹🇷' },
    { code: '+91', country: 'India', flag: '🇮🇳' },
    { code: '+92', country: 'Pakistan', flag: '🇵🇰' },
    { code: '+93', country: 'Afghanistan', flag: '🇦🇫' },
    { code: '+94', country: 'Sri Lanka', flag: '🇱🇰' },
    { code: '+95', country: 'Myanmar', flag: '🇲🇲' },
    { code: '+98', country: 'Iran', flag: '🇮🇷' },
    { code: '+212', country: 'Morocco', flag: '🇲🇦' },
    { code: '+213', country: 'Algeria', flag: '🇩🇿' },
    { code: '+216', country: 'Tunisia', flag: '🇹🇳' },
    { code: '+218', country: 'Libya', flag: '🇱🇾' },
    { code: '+220', country: 'Gambia', flag: '🇬🇲' },
    { code: '+221', country: 'Senegal', flag: '🇸🇳' },
    { code: '+222', country: 'Mauritania', flag: '🇲🇷' },
    { code: '+223', country: 'Mali', flag: '🇲🇱' },
    { code: '+224', country: 'Guinea', flag: '🇬🇳' },
    { code: '+225', country: 'Ivory Coast', flag: '🇨🇮' },
    { code: '+226', country: 'Burkina Faso', flag: '🇧🇫' },
    { code: '+227', country: 'Niger', flag: '🇳🇪' },
    { code: '+228', country: 'Togo', flag: '🇹🇬' },
    { code: '+229', country: 'Benin', flag: '🇧🇯' },
    { code: '+230', country: 'Mauritius', flag: '🇲🇺' },
    { code: '+231', country: 'Liberia', flag: '🇱🇷' },
    { code: '+232', country: 'Sierra Leone', flag: '🇸🇱' },
    { code: '+233', country: 'Ghana', flag: '🇬🇭' },
    { code: '+234', country: 'Nigeria', flag: '🇳🇬' },
    { code: '+235', country: 'Chad', flag: '🇹🇩' },
    { code: '+236', country: 'Central African Republic', flag: '🇨🇫' },
    { code: '+237', country: 'Cameroon', flag: '🇨🇲' },
    { code: '+238', country: 'Cape Verde', flag: '🇨🇻' },
    { code: '+239', country: 'São Tomé and Príncipe', flag: '🇸🇹' },
    { code: '+240', country: 'Equatorial Guinea', flag: '🇬🇶' },
    { code: '+241', country: 'Gabon', flag: '🇬🇦' },
    { code: '+242', country: 'Republic of the Congo', flag: '🇨🇬' },
    { code: '+243', country: 'Democratic Republic of the Congo', flag: '🇨🇩' },
    { code: '+244', country: 'Angola', flag: '🇦🇴' },
    { code: '+245', country: 'Guinea-Bissau', flag: '🇬🇼' },
    { code: '+246', country: 'British Indian Ocean Territory', flag: '🇮🇴' },
    { code: '+248', country: 'Seychelles', flag: '🇸🇨' },
    { code: '+249', country: 'Sudan', flag: '🇸🇩' },
    { code: '+250', country: 'Rwanda', flag: '🇷🇼' },
    { code: '+251', country: 'Ethiopia', flag: '🇪🇹' },
    { code: '+252', country: 'Somalia', flag: '🇸🇴' },
    { code: '+253', country: 'Djibouti', flag: '🇩🇯' },
    { code: '+254', country: 'Kenya', flag: '🇰🇪' },
    { code: '+255', country: 'Tanzania', flag: '🇹🇿' },
    { code: '+256', country: 'Uganda', flag: '🇺🇬' },
    { code: '+257', country: 'Burundi', flag: '🇧🇮' },
    { code: '+258', country: 'Mozambique', flag: '🇲🇿' },
    { code: '+260', country: 'Zambia', flag: '🇿🇲' },
    { code: '+261', country: 'Madagascar', flag: '🇲🇬' },
    { code: '+262', country: 'Réunion', flag: '🇷🇪' },
    { code: '+263', country: 'Zimbabwe', flag: '🇿🇼' },
    { code: '+264', country: 'Namibia', flag: '🇳🇦' },
    { code: '+265', country: 'Malawi', flag: '🇲🇼' },
    { code: '+266', country: 'Lesotho', flag: '🇱🇸' },
    { code: '+267', country: 'Botswana', flag: '🇧🇼' },
    { code: '+268', country: 'Eswatini', flag: '🇸🇿' },
    { code: '+269', country: 'Comoros', flag: '🇰🇲' },
    { code: '+290', country: 'Saint Helena', flag: '🇸🇭' },
    { code: '+291', country: 'Eritrea', flag: '🇪🇷' },
    { code: '+297', country: 'Aruba', flag: '🇦🇼' },
    { code: '+298', country: 'Faroe Islands', flag: '🇫🇴' },
    { code: '+299', country: 'Greenland', flag: '🇬🇱' },
    { code: '+350', country: 'Gibraltar', flag: '🇬🇮' },
    { code: '+351', country: 'Portugal', flag: '🇵🇹' },
    { code: '+352', country: 'Luxembourg', flag: '🇱🇺' },
    { code: '+353', country: 'Ireland', flag: '🇮🇪' },
    { code: '+354', country: 'Iceland', flag: '🇮🇸' },
    { code: '+355', country: 'Albania', flag: '🇦🇱' },
    { code: '+356', country: 'Malta', flag: '🇲🇹' },
    { code: '+357', country: 'Cyprus', flag: '🇨🇾' },
    { code: '+358', country: 'Finland', flag: '🇫🇮' },
    { code: '+359', country: 'Bulgaria', flag: '🇧🇬' },
    { code: '+370', country: 'Lithuania', flag: '🇱🇹' },
    { code: '+371', country: 'Latvia', flag: '🇱🇻' },
    { code: '+372', country: 'Estonia', flag: '🇪🇪' },
    { code: '+373', country: 'Moldova', flag: '🇲🇩' },
    { code: '+374', country: 'Armenia', flag: '🇦🇲' },
    { code: '+375', country: 'Belarus', flag: '🇧🇾' },
    { code: '+376', country: 'Andorra', flag: '🇦🇩' },
    { code: '+377', country: 'Monaco', flag: '🇲🇨' },
    { code: '+378', country: 'San Marino', flag: '🇸🇲' },
    { code: '+380', country: 'Ukraine', flag: '🇺🇦' },
    { code: '+381', country: 'Serbia', flag: '🇷🇸' },
    { code: '+382', country: 'Montenegro', flag: '🇲🇪' },
    { code: '+383', country: 'Kosovo', flag: '🇽🇰' },
    { code: '+385', country: 'Croatia', flag: '🇭🇷' },
    { code: '+386', country: 'Slovenia', flag: '🇸🇮' },
    { code: '+387', country: 'Bosnia and Herzegovina', flag: '🇧🇦' },
    { code: '+389', country: 'North Macedonia', flag: '🇲🇰' },
    { code: '+420', country: 'Czech Republic', flag: '🇨🇿' },
    { code: '+421', country: 'Slovakia', flag: '🇸🇰' },
    { code: '+423', country: 'Liechtenstein', flag: '🇱🇮' },
    { code: '+500', country: 'Falkland Islands', flag: '🇫🇰' },
    { code: '+501', country: 'Belize', flag: '🇧🇿' },
    { code: '+502', country: 'Guatemala', flag: '🇬🇹' },
    { code: '+503', country: 'El Salvador', flag: '🇸🇻' },
    { code: '+504', country: 'Honduras', flag: '🇭🇳' },
    { code: '+505', country: 'Nicaragua', flag: '🇳🇮' },
    { code: '+506', country: 'Costa Rica', flag: '🇨🇷' },
    { code: '+507', country: 'Panama', flag: '🇵🇦' },
    { code: '+508', country: 'Saint Pierre and Miquelon', flag: '🇵🇲' },
    { code: '+509', country: 'Haiti', flag: '🇭🇹' },
    { code: '+590', country: 'Guadeloupe', flag: '🇬🇵' },
    { code: '+591', country: 'Bolivia', flag: '🇧🇴' },
    { code: '+592', country: 'Guyana', flag: '🇬🇾' },
    { code: '+593', country: 'Ecuador', flag: '🇪🇨' },
    { code: '+594', country: 'French Guiana', flag: '🇬🇫' },
    { code: '+595', country: 'Paraguay', flag: '🇵🇾' },
    { code: '+596', country: 'Martinique', flag: '🇲🇶' },
    { code: '+597', country: 'Suriname', flag: '🇸🇷' },
    { code: '+598', country: 'Uruguay', flag: '🇺🇾' },
    { code: '+599', country: 'Curaçao', flag: '🇨🇼' },
    { code: '+670', country: 'East Timor', flag: '🇹🇱' },
    { code: '+672', country: 'Antarctica', flag: '🇦🇶' },
    { code: '+673', country: 'Brunei', flag: '🇧🇳' },
    { code: '+674', country: 'Nauru', flag: '🇳🇷' },
    { code: '+675', country: 'Papua New Guinea', flag: '🇵🇬' },
    { code: '+676', country: 'Tonga', flag: '🇹🇴' },
    { code: '+677', country: 'Solomon Islands', flag: '🇸🇧' },
    { code: '+678', country: 'Vanuatu', flag: '🇻🇺' },
    { code: '+679', country: 'Fiji', flag: '🇫🇯' },
    { code: '+680', country: 'Palau', flag: '🇵🇼' },
    { code: '+681', country: 'Wallis and Futuna', flag: '🇼🇫' },
    { code: '+682', country: 'Cook Islands', flag: '🇨🇰' },
    { code: '+683', country: 'Niue', flag: '🇳🇺' },
    { code: '+684', country: 'American Samoa', flag: '🇦🇸' },
    { code: '+685', country: 'Samoa', flag: '🇼🇸' },
    { code: '+686', country: 'Kiribati', flag: '🇰🇮' },
    { code: '+687', country: 'New Caledonia', flag: '🇳🇨' },
    { code: '+688', country: 'Tuvalu', flag: '🇹🇻' },
    { code: '+689', country: 'French Polynesia', flag: '🇵🇫' },
    { code: '+690', country: 'Tokelau', flag: '🇹🇰' },
    { code: '+691', country: 'Micronesia', flag: '🇫🇲' },
    { code: '+692', country: 'Marshall Islands', flag: '🇲🇭' },
    { code: '+850', country: 'North Korea', flag: '🇰🇵' },
    { code: '+852', country: 'Hong Kong', flag: '🇭🇰' },
    { code: '+853', country: 'Macau', flag: '🇲🇴' },
    { code: '+855', country: 'Cambodia', flag: '🇰🇭' },
    { code: '+856', country: 'Laos', flag: '🇱🇦' },
    { code: '+880', country: 'Bangladesh', flag: '🇧🇩' },
    { code: '+886', country: 'Taiwan', flag: '🇹🇼' },
    { code: '+960', country: 'Maldives', flag: '🇲🇻' },
    { code: '+961', country: 'Lebanon', flag: '🇱🇧' },
    { code: '+962', country: 'Jordan', flag: '🇯🇴' },
    { code: '+963', country: 'Syria', flag: '🇸🇾' },
    { code: '+964', country: 'Iraq', flag: '🇮🇶' },
    { code: '+965', country: 'Kuwait', flag: '🇰🇼' },
    { code: '+966', country: 'Saudi Arabia', flag: '🇸🇦' },
    { code: '+967', country: 'Yemen', flag: '🇾🇪' },
    { code: '+968', country: 'Oman', flag: '🇴🇲' },
    { code: '+970', country: 'Palestine', flag: '🇵🇸' },
    { code: '+971', country: 'United Arab Emirates', flag: '🇦🇪' },
    { code: '+972', country: 'Israel', flag: '🇮🇱' },
    { code: '+973', country: 'Bahrain', flag: '🇧🇭' },
    { code: '+974', country: 'Qatar', flag: '🇶🇦' },
    { code: '+975', country: 'Bhutan', flag: '🇧🇹' },
    { code: '+976', country: 'Mongolia', flag: '🇲🇳' },
    { code: '+977', country: 'Nepal', flag: '🇳🇵' },
    { code: '+992', country: 'Tajikistan', flag: '🇹🇯' },
    { code: '+993', country: 'Turkmenistan', flag: '🇹🇲' },
    { code: '+994', country: 'Azerbaijan', flag: '🇦🇿' },
    { code: '+995', country: 'Georgia', flag: '🇬🇪' },
    { code: '+996', country: 'Kyrgyzstan', flag: '🇰🇬' },
    { code: '+998', country: 'Uzbekistan', flag: '🇺🇿' }
  ];

  // Listen to Firebase auth state changes
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setIsLoggedIn(true);
        // Fetch user profile from backend
        try {
          const response = await apiClient.get('/auth/me', {
            headers: {
              Authorization: `Bearer ${await user.getIdToken()}`
            }
          });
          setUserInfo({
            name: response.data.displayName || 'User',
            email: response.data.email,
            phone: response.data.phone || '',
            address: response.data.address || '',
          });
        } catch (err) {
          console.error('Error fetching user profile:', err);
          // Fallback to Firebase user data
          setUserInfo({
            name: user.displayName || 'User',
            email: user.email,
            phone: '',
            address: '',
          });
        }
      } else {
        setIsLoggedIn(false);
        setUserInfo({
          name: '',
          email: '',
          phone: '',
          address: '',
        });
      }
    });

    return () => unsubscribe();
  }, []);

  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (form.password !== form.confirmPassword) {
      setError('Passwords do not match!');
      toast.error('Passwords do not match!');
      setLoading(false);
      return;
    }

    if (form.password.length < 6) {
      setError('Password must be at least 6 characters long');
      toast.error('Password must be at least 6 characters long');
      setLoading(false);
      return;
    }

    try {
      if (!emailOtpSent) {
        // Step 1: Send OTP
        const response = await apiClient.post('/auth/send-otp', {
          email: form.email,
          type: 'signup'
        });

        if (response.data.message) {
          setEmailOtpSent(true);
          toast.success('OTP sent to your email! Please verify to continue.');
        }
      } else {
        // Step 2: Verify OTP and Signup
        if (!form.emailOtp) {
          setError('Please enter the OTP sent to your email');
          toast.error('Please enter the OTP sent to your email');
          setLoading(false);
          return;
        }

        await apiClient.post('/auth/verify-otp', {
          email: form.email,
          otp: form.emailOtp
        });

        // If OTP verified, proceed with Firebase Signup
        await firebaseAuth.signup(form.email, form.password, form.name);

        // Create user in backend
        await apiClient.post('/auth/signup', {
          email: form.email,
          password: form.password,
          displayName: form.name
        });

        setForm({ email: '', password: '', confirmPassword: '', name: '', phone: '', otp: '', emailOtp: '' });
        setEmailOtpSent(false);
        toast.success('Account created successfully! You are now logged in.');
      }
    } catch (error) {
      console.error('Signup error:', error);
      let errorMsg = error.response?.data?.error;

      if (!errorMsg) {
        if (error.code === 'auth/email-already-in-use' || error.message.includes('auth/email-already-in-use')) {
          errorMsg = 'Email is already registered. Please login instead.';
        } else if (error.code === 'auth/weak-password' || error.message.includes('auth/weak-password')) {
          errorMsg = 'Password is too weak. Please use a stronger password.';
        } else {
          errorMsg = error.message || 'Failed to create account.';
          // Clean up generic firebase messages
          if (errorMsg.includes('Firebase:')) {
            errorMsg = errorMsg.replace('Firebase: ', '').replace('Error ', '').replace(/\(auth\/.*\)\.?/, '').trim();
          }
        }
      }

      setError(errorMsg);
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (!form.email || !form.password) {
      setError('Please enter email and password!');
      setLoading(false);
      return;
    }

    try {
      await firebaseAuth.login(form.email, form.password);
      setForm({ email: '', password: '', confirmPassword: '', name: '', phone: '', otp: '', emailOtp: '' });
      toast.success('Logged in successfully!');

      if (location.state?.from) {
        navigate(location.state.from);
      }
    } catch (error) {
      console.error('Login error:', error);
      let errorMessage = 'Login failed. Please check your credentials.';

      // Map Firebase error codes to user-friendly messages
      if (error.code === 'auth/invalid-credential' || error.message.includes('auth/invalid-credential')) {
        errorMessage = 'Invalid email or password. Please try again.';
      } else if (error.code === 'auth/user-not-found' || error.message.includes('auth/user-not-found')) {
        errorMessage = 'No account found with this email.';
      } else if (error.code === 'auth/wrong-password' || error.message.includes('auth/wrong-password')) {
        errorMessage = 'Incorrect password. Please try again.';
      } else if (error.code === 'auth/too-many-requests' || error.message.includes('auth/too-many-requests')) {
        errorMessage = 'Too many failed attempts. Please try again later.';
      } else if (error.message) {
        // Clean up other firebase messages if needed
        errorMessage = error.message.replace('Firebase: ', '').replace('Error ', '').replace(/\(auth\/.*\)\.?/, '').trim();
      }

      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await firebaseAuth.logout();
      setForm({ email: '', password: '', confirmPassword: '', name: '', phone: '', otp: '', emailOtp: '' });
      setMode('login');
      toast.success('Logged out successfully!');
    } catch (error) {
      console.error('Logout error:', error);
      toast.error('Error logging out. Please try again.');
    }
  };

  const handleProfileUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const user = auth.currentUser;
      if (!user) {
        setError('You must be logged in to update your profile.');
        return;
      }

      const idToken = await user.getIdToken();
      await apiClient.put('/auth/me', {
        displayName: userInfo.name,
        phone: userInfo.phone,
        address: userInfo.address
      }, {
        headers: {
          Authorization: `Bearer ${idToken}`
        }
      });

      toast.success('Profile updated successfully!');
    } catch (error) {
      console.error('Profile update error:', error);
      setError(error.response?.data?.error || 'Failed to update profile. Please try again.');
      toast.error(error.response?.data?.error || 'Failed to update profile. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError('');

    try {
      const result = await firebaseAuth.loginWithGoogle();
      const user = result.user;

      // Check if user exists in backend, if not create them
      try {
        await apiClient.post('/auth/signup', {
          email: user.email,
          displayName: user.displayName || user.email.split('@')[0]
        });
      } catch (backendError) {
        // User might already exist, that's okay

      }

      toast.success('Logged in with Google successfully!');
    } catch (error) {
      console.error('Google login error:', error);
      let errorMsg = error.message || 'Google login failed. Please try again.';
      if (errorMsg.includes('Firebase:')) {
        errorMsg = errorMsg.replace('Firebase: ', '').replace('Error ', '').replace(/\(auth\/.*\)\.?/, '').trim();
      }
      setError(errorMsg);
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handlePhoneAuth = async () => {
    setLoading(true);
    setError('');

    if (!form.phone) {
      setError('Please enter your phone number');
      setLoading(false);
      return;
    }

    // Format phone number with selected country code
    let phoneNumber = form.phone;

    if (!phoneNumber.startsWith('+')) {
      if (!phoneAuth.countryCode) {
        toast.error('Please select a country code.');
        setLoading(false);
        return;
      }
      phoneNumber = phoneAuth.countryCode + phoneNumber;
    }

    try {
      // Clear existing verifier if it exists
      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.clear();
      }

      const recaptchaVerifier = firebaseAuth.setupRecaptcha('recaptcha-container');
      window.recaptchaVerifier = recaptchaVerifier; // Store it

      const confirmationResult = await firebaseAuth.loginWithPhone(phoneNumber, recaptchaVerifier);

      setPhoneAuth({
        ...phoneAuth,
        verificationId: confirmationResult.verificationId,
        isOtpSent: true,
        isPhoneMode: true
      });

      toast.success('OTP sent to your phone number!');
    } catch (error) {
      console.error('Phone auth error:', error);
      let errorMsg = error.message || 'Failed to send OTP. Please try again.';

      if (error.code === 'auth/billing-not-enabled' || error.message.includes('billing-not-enabled')) {
        errorMsg = 'Phone authentication requires billing to be enabled in Firebase Console. Please upgrade to Blaze plan (free tier still applies).';
      } else if (error.code === 'auth/invalid-app-credential' || error.message.includes('invalid-app-credential')) {
        errorMsg = 'App verification failed. If testing locally, try adding "127.0.0.1" to Firebase Authorized Domains or use a Test Phone Number.';
      } else if (error.code === 'auth/too-many-requests') {
        errorMsg = 'Too many requests. Please try again later or use a Test Phone Number.';
      } else if (errorMsg.includes('Firebase:')) {
        errorMsg = errorMsg.replace('Firebase: ', '').replace('Error ', '').replace(/\(auth\/.*\)\.?/, '').trim();
      }
      setError(errorMsg);
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleOtpVerification = async () => {
    setLoading(true);
    setError('');

    if (!form.otp) {
      setError('Please enter the OTP');
      setLoading(false);
      return;
    }

    try {
      // Import the confirmation result function
      const { getAuth, signInWithCredential, PhoneAuthProvider } = await import('firebase/auth');
      const authInstance = getAuth();
      const credential = PhoneAuthProvider.credential(phoneAuth.verificationId, form.otp);
      const result = await signInWithCredential(authInstance, credential);

      const user = result.user;

      // Check if user exists in backend, if not create them
      try {
        await apiClient.post('/auth/signup', {
          email: user.phoneNumber + '@phone.local', // Create email-like identifier
          displayName: 'Phone User'
        });
      } catch (backendError) {

      }

      // Reset phone auth state
      setPhoneAuth({
        ...phoneAuth,
        verificationId: null,
        isOtpSent: false,
        isPhoneMode: false
      });

      toast.success('Phone number verified successfully!');
    } catch (error) {
      console.error('OTP verification error:', error);
      let errorMsg = error.message || 'Invalid OTP. Please try again.';
      if (error.code === 'auth/invalid-verification-code') {
        errorMsg = 'Invalid OTP. Please check and try again.';
      } else if (errorMsg.includes('Firebase:')) {
        errorMsg = errorMsg.replace('Firebase: ', '').replace('Error ', '').replace(/\(auth\/.*\)\.?/, '').trim();
      }
      setError(errorMsg);
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (!form.email) {
      setError('Please enter your email address');
      setLoading(false);
      return;
    }

    try {
      if (!emailOtpSent) {
        // Step 1: Send OTP for Password Reset
        const response = await apiClient.post('/auth/send-otp', {
          email: form.email,
          type: 'reset'
        });

        if (response.data.message) {
          setEmailOtpSent(true);
          toast.success('OTP sent to your email! Please verify to reset password.');
        }
      } else {
        // Step 2: Verify OTP and Reset Password
        if (!form.emailOtp) {
          setError('Please enter the OTP sent to your email');
          setLoading(false);
          return;
        }

        if (!form.password || !form.confirmPassword) {
          setError('Please enter and confirm your new password');
          setLoading(false);
          return;
        }

        if (form.password !== form.confirmPassword) {
          setError('Passwords do not match!');
          setLoading(false);
          return;
        }

        if (form.password.length < 6) {
          setError('Password must be at least 6 characters long');
          setLoading(false);
          return;
        }

        await apiClient.post('/auth/reset-password', {
          email: form.email,
          otp: form.emailOtp,
          newPassword: form.password
        });

        setForm({ email: '', password: '', confirmPassword: '', name: '', phone: '', otp: '', emailOtp: '' });
        setEmailOtpSent(false);
        setMode('login');
        toast.success('Password reset successfully! Please login with your new password.');
      }
    } catch (error) {
      console.error('Reset password error:', error);
      let errorMsg = error.response?.data?.error;

      if (!errorMsg) {
        errorMsg = error.message || 'Failed to reset password.';
        // Clean up generic firebase messages if they somehow leak through
        if (errorMsg.includes('Firebase:')) {
          errorMsg = errorMsg.replace('Firebase: ', '').replace('Error ', '').replace(/\(auth\/.*\)\.?/, '').trim();
        }
      }

      setError(errorMsg);
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="account-page">
      <div className="account-container">
        {!isLoggedIn ? (
          <div className="login-section">
            <div className="login-card">
              <div className="auth-tabs">
                <button
                  className={`tab-btn ${mode === 'login' ? 'active' : ''}`}
                  onClick={() => setMode('login')}
                >
                  Login
                </button>
                <button
                  className={`tab-btn ${mode === 'signup' ? 'active' : ''}`}
                  onClick={() => setMode('signup')}
                >
                  Sign Up
                </button>
              </div>

              {mode === 'login' ? (
                <div className="login-section-content">
                  <form onSubmit={handleLogin} className="login-form">
                    <h2>Login to Your Account</h2>
                    {error && <div className="error-message">{error}</div>}
                    <div className="form-group">
                      <label>Email</label>
                      <input
                        type="email"
                        placeholder="Enter your email"
                        value={form.email}
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                        required
                        disabled={loading}
                      />
                    </div>

                    <div className="form-group">
                      <label>Password</label>
                      <div className="password-input-container">
                        <input
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter your password"
                          value={form.password}
                          onChange={(e) => setForm({ ...form, password: e.target.value })}
                          required
                          disabled={loading}
                        />
                        <span
                          className="password-toggle-icon"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? <FiEyeOff /> : <FiEye />}
                        </span>
                      </div>
                      <div className="forgot-password-link">
                        <span onClick={() => {
                          setMode('reset');
                          setError('');
                          setForm({ ...form, email: '', password: '', confirmPassword: '', otp: '', emailOtp: '' });
                          setEmailOtpSent(false);
                        }}>
                          Forgot Password?
                        </span>
                      </div>
                    </div>

                    <button type="submit" className="login-btn" disabled={loading}>
                      {loading ? 'Logging in...' : 'Login'}
                    </button>
                  </form>

                  <div className="social-login-divider">
                    <span>or continue with</span>
                  </div>

                  <div className="social-login-buttons">
                    <button
                      type="button"
                      className="social-btn google-btn"
                      onClick={handleGoogleLogin}
                      disabled={loading}
                    >
                      <svg className="social-icon" viewBox="0 0 24 24">
                        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                      </svg>
                      {loading ? 'Connecting...' : 'Continue with Google'}
                    </button>

                    <button
                      type="button"
                      className="social-btn phone-btn"
                      onClick={() => setPhoneAuth({ ...phoneAuth, isPhoneMode: !phoneAuth.isPhoneMode })}
                      disabled={loading}
                    >
                      <svg className="social-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                      </svg>
                      {loading ? 'Connecting...' : 'Continue with Phone'}
                    </button>
                  </div>

                  {phoneAuth.isPhoneMode && (
                    <div className="phone-auth-section">
                      {!phoneAuth.isOtpSent ? (
                        <div className="phone-input-section">
                          <h3>Phone Number Authentication</h3>
                          <div className="form-group">
                            <label>Phone Number</label>
                            <div className="phone-input-container">
                              <select
                                className="country-code-select"
                                value={phoneAuth.countryCode}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  if (val) {
                                    setPhoneAuth({ ...phoneAuth, countryCode: val });
                                  }
                                }}
                                disabled={loading}
                              >
                                {countryCodes.map((country) => (
                                  <option key={country.code} value={country.code}>
                                    {country.flag} {country.code} ({country.country})
                                  </option>
                                ))}
                              </select>
                              <input
                                type="tel"
                                className="phone-number-input"
                                placeholder="Enter phone number"
                                value={form.phone}
                                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                                disabled={loading}
                              />
                            </div>
                            <small className="input-help">Enter your phone number without the country code</small>
                          </div>
                          <button
                            type="button"
                            className="phone-auth-btn"
                            onClick={handlePhoneAuth}
                            disabled={loading || !form.phone}
                          >
                            {loading ? 'Sending OTP...' : 'Send OTP'}
                          </button>
                        </div>
                      ) : (
                        <div className="otp-input-section">
                          <h3>Enter OTP</h3>
                          <p>OTP sent to {phoneAuth.countryCode + form.phone}</p>
                          <div className="form-group">
                            <label>OTP</label>
                            <input
                              type="text"
                              placeholder="Enter 6-digit OTP"
                              value={form.otp}
                              onChange={(e) => setForm({ ...form, otp: e.target.value })}
                              maxLength="6"
                              disabled={loading}
                            />
                          </div>
                          <div className="otp-buttons">
                            <button
                              type="button"
                              className="otp-verify-btn"
                              onClick={handleOtpVerification}
                              disabled={loading || !form.otp}
                            >
                              {loading ? 'Verifying...' : 'Verify OTP'}
                            </button>
                            <button
                              type="button"
                              className="otp-resend-btn"
                              onClick={() => {
                                setPhoneAuth({ ...phoneAuth, isOtpSent: false });
                                setForm({ ...form, otp: '' });
                              }}
                              disabled={loading}
                            >
                              Change Number
                            </button>
                          </div>
                        </div>
                      )}
                      <div id="recaptcha-container"></div>
                    </div>
                  )}
                </div>
              ) : mode === 'signup' ? (
                <form onSubmit={handleSignup} className="login-form">
                  <h2>Create New Account</h2>
                  {error && <div className="error-message">{error}</div>}

                  {!emailOtpSent ? (
                    <>
                      <div className="form-group">
                        <label>Full Name</label>
                        <input
                          type="text"
                          placeholder="Enter your full name"
                          value={form.name}
                          onChange={(e) => setForm({ ...form, name: e.target.value })}
                          required
                          disabled={loading}
                        />
                      </div>

                      <div className="form-group">
                        <label>Email</label>
                        <input
                          type="email"
                          placeholder="Enter your email"
                          value={form.email}
                          onChange={(e) => setForm({ ...form, email: e.target.value })}
                          required
                          disabled={loading}
                        />
                      </div>

                      <div className="form-group">
                        <label>Password</label>
                        <div className="password-input-container">
                          <input
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter password (min 6 characters)"
                            value={form.password}
                            onChange={(e) => setForm({ ...form, password: e.target.value })}
                            required
                            disabled={loading}
                          />
                          <span
                            className="password-toggle-icon"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? <FiEyeOff /> : <FiEye />}
                          </span>
                        </div>
                      </div>

                      <div className="form-group">
                        <label>Confirm Password</label>
                        <div className="password-input-container">
                          <input
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Confirm your password"
                            value={form.confirmPassword}
                            onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })}
                            required
                            disabled={loading}
                          />
                          <span
                            className="password-toggle-icon"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          >
                            {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
                          </span>
                        </div>
                      </div>

                      <button type="submit" className="login-btn" disabled={loading}>
                        {loading ? 'Sending OTP...' : 'Sign Up & Send OTP'}
                      </button>
                    </>
                  ) : (
                    <div className="otp-input-section">
                      <h3>Verify Email</h3>
                      <p>OTP sent to {form.email}</p>
                      <div className="form-group">
                        <label>Enter OTP</label>
                        <input
                          type="text"
                          placeholder="Enter 6-digit OTP"
                          value={form.emailOtp}
                          onChange={(e) => setForm({ ...form, emailOtp: e.target.value })}
                          maxLength="6"
                          required
                          disabled={loading}
                        />
                      </div>
                      <div className="otp-buttons">
                        <button type="submit" className="otp-verify-btn" disabled={loading}>
                          {loading ? 'Verifying...' : 'Verify & Register'}
                        </button>
                        <button
                          type="button"
                          className="otp-resend-btn"
                          onClick={() => setEmailOtpSent(false)}
                          disabled={loading}
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  )}
                </form>
              ) : (
                <form onSubmit={handleResetPassword} className="login-form">
                  <h2>Reset Password</h2>
                  {error && <div className="error-message">{error}</div>}

                  {!emailOtpSent ? (
                    <>
                      <div className="form-group">
                        <label>Email Address</label>
                        <input
                          type="email"
                          placeholder="Enter your registered email"
                          value={form.email}
                          onChange={(e) => setForm({ ...form, email: e.target.value })}
                          required
                          disabled={loading}
                        />
                      </div>

                      <button type="submit" className="login-btn" disabled={loading}>
                        {loading ? 'Sending OTP...' : 'Send OTP'}
                      </button>

                      <div className="back-to-login" style={{ marginTop: '15px', textAlign: 'center', cursor: 'pointer', color: '#666' }}>
                        <span onClick={() => setMode('login')}>Back to Login</span>
                      </div>
                    </>
                  ) : (
                    <div className="otp-input-section">
                      <h3>Verify & Reset</h3>
                      <p>OTP sent to {form.email}</p>

                      <div className="form-group">
                        <label>Enter OTP</label>
                        <input
                          type="text"
                          placeholder="Enter 6-digit OTP"
                          value={form.emailOtp}
                          onChange={(e) => setForm({ ...form, emailOtp: e.target.value })}
                          maxLength="6"
                          required
                          disabled={loading}
                        />
                      </div>

                      <div className="form-group">
                        <label>New Password</label>
                        <div className="password-input-container">
                          <input
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter new password"
                            value={form.password}
                            onChange={(e) => setForm({ ...form, password: e.target.value })}
                            required
                            disabled={loading}
                          />
                          <span
                            className="password-toggle-icon"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? <FiEyeOff /> : <FiEye />}
                          </span>
                        </div>
                      </div>

                      <div className="form-group">
                        <label>Confirm New Password</label>
                        <div className="password-input-container">
                          <input
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Confirm new password"
                            value={form.confirmPassword}
                            onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })}
                            required
                            disabled={loading}
                          />
                          <span
                            className="password-toggle-icon"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          >
                            {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
                          </span>
                        </div>
                      </div>

                      <div className="otp-buttons">
                        <button type="submit" className="otp-verify-btn" disabled={loading}>
                          {loading ? 'Resetting...' : 'Reset Password'}
                        </button>
                        <button
                          type="button"
                          className="otp-resend-btn"
                          onClick={() => setEmailOtpSent(false)}
                          disabled={loading}
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  )}
                </form>
              )}
            </div>
          </div>
        ) : (
          <div className="account-content">
            <div className="account-header">
              <div className="user-greeting">
                <FiUser size={40} />
                <div>
                  <h1>Welcome, {userInfo.name}!</h1>
                  <p>{userInfo.email}</p>
                </div>
              </div>
            </div>

            <div className="account-tabs">
              <button
                className={`tab-btn ${activeTab === 'profile' ? 'active' : ''}`}
                onClick={() => setActiveTab('profile')}
              >
                <FiUser /> Profile
              </button>
              <button
                className={`tab-btn ${activeTab === 'addresses' ? 'active' : ''}`}
                onClick={() => setActiveTab('addresses')}
              >
                <FiMapPin /> Addresses
              </button>
            </div>

            <div className="account-panel">
              {activeTab === 'profile' ? (
                <div className="profile-section">
                  <h2>Profile Information</h2>
                  <form onSubmit={handleProfileUpdate} className="profile-form">
                    <div className="form-group">
                      <label>Full Name</label>
                      <input
                        type="text"
                        value={userInfo.name}
                        onChange={(e) => setUserInfo({ ...userInfo, name: e.target.value })}
                      />
                    </div>

                    <div className="form-group">
                      <label>Email</label>
                      <input type="email" value={userInfo.email} disabled />
                    </div>

                    <div className="form-group">
                      <label>Phone</label>
                      <input
                        type="tel"
                        value={userInfo.phone || ''}
                        onChange={(e) => setUserInfo({ ...userInfo, phone: e.target.value })}
                        placeholder="Enter your phone number"
                      />
                    </div>

                    <button type="submit" className="save-profile-btn" disabled={loading}>
                      {loading ? 'Updating...' : 'Update Profile'}
                    </button>
                  </form>
                </div>
              ) : (
                <div className="addresses-section">
                  <Addresses />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Account;
